import { SilverbackPageContext } from '@amazeelabs/gatsby-source-silverback';
import { buildUrl, ContentRoute,RouteSlotInput  } from '@caritas/ui';

import { buildMessages, redirectWithUserUpdate } from '../../utils/iframe';

export const mapMyProfileBlock = (
  pageContext: SilverbackPageContext,
) =>
  function (): RouteSlotInput<typeof ContentRoute, 'body', 'formEmbed'> {
    return {
      key: 'formEmbed',
      input: function useMyProfileBlock() {
        return [
          {
            url: buildUrl(
              [
                process.env.GATSBY_DRUPAL_CLIENT_URL || '/',
                pageContext.locale,
                'cms',
                'pages',
                'my_profile',
              ],
            ),
            buildMessages: buildMessages(),
            redirect: redirectWithUserUpdate,
          },
          200,
        ];
      },
    };
  };
